import { render, staticRenderFns } from "./pagoVocal.vue?vue&type=template&id=ba446ffa&scoped=true"
import script from "./pagoVocal.vue?vue&type=script&lang=js"
export * from "./pagoVocal.vue?vue&type=script&lang=js"
import style0 from "./pagoVocal.vue?vue&type=style&index=0&id=ba446ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba446ffa",
  null
  
)

export default component.exports